import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Component } from "react";
import { selectedAutomationNode } from "../../Template/NewTemplateSignals";

export class ExpressionProperty extends Component {
  constructor({ value, handlePropertyChange }) {
    super();
    this.state = {
      value: value || "",
    };
    this.handlePropertyChange = handlePropertyChange;
  }

  render() {
    return (
      <div
        key={`${selectedAutomationNode.value.options.id}`}
        className="k-my-2 k-mx-2"
      >
        <Label style={{ fontSize: "14px", fontWeight: "600" }}>Expression:</Label>
        <Input
          value={this.state.value}
          onChange={(e) => this.setState({ value: e.target.value })}
          onBlur={() => {
            this.handlePropertyChange({
              e: { target: { value: this.state.value } },
              propertyName: "Expression",
            });
          }}
        />
      </div>
    );
  }
}
